const villes = [
  { label: "Strasbourg", href: "/" },
  { label: "Haguenau", href: "/haguenau" },
  { label: "Schiltigheim", href: "/schiltigheim" },
  { label: "Illkirch-Graffenstaden", href: "/illkirch-graffenstaden" },
  { label: "Sélestat", href: "/selestat" },
  { label: "Lingolsheim", href: "/lingolsheim" },
  { label: "Bischheim", href: "/bischheim" },
  { label: "Bischwiller", href: "/bischwiller" },
  { label: "Ostwald", href: "/ostwald" },
  { label: "Saverne", href: "/saverne" },
  { label: "Obernai", href: "/obernai" },
];

export default function Zones() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <p className="text-secondary-600 text-xs font-medium uppercase tracking-wider mb-2 text-center">
          Bas-Rhin &amp; environs
        </p>
        <h2 className="text-foreground-950 text-2xl md:text-3xl font-extrabold text-center mb-3">
          Nous intervenons partout dans le Bas-Rhin
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center max-w-2xl mx-auto mb-8 md:mb-12">
          Techniciens locaux basés à Strasbourg, déplacement rapide dans toutes les communes du Bas-Rhin.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {villes.map((v) => (
            <a
              key={v.href}
              href={v.href}
              className="group flex items-center gap-2.5 bg-white border border-background-200 rounded-lg px-3 py-2.5 md:px-4 md:py-3 hover:border-primary-400 hover:shadow-sm transition-all"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
                <i className="ri-map-pin-line text-sm"></i>
              </span>
              <span className="text-foreground-800 text-sm font-medium group-hover:text-primary-600 transition-colors min-w-0 break-words leading-tight">
                {v.label}
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <a
            href="/zones-d-intervention"
            className="inline-flex items-center gap-2 text-primary-600 text-sm font-semibold hover:text-primary-700 transition-colors min-w-0"
          >
            Voir toutes les zones d'intervention
            <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}